var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"fun none-fluid link"},[_c('banner',[_vm._v("Fun")]),_c('div',{staticClass:"mx-auto fun-content"},_vm._l((_vm.links),function(link){return _c('div',{key:link},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$sanitize(link))}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }